const uiComponentsConfig = {
  closeAnimationInMs: 500,
  dialogHeaderHeight: 85,
} as const;

export default uiComponentsConfig;
